export default __webpack_public_path__ + "static/giotto-plus-scheda-tecnica-89b52821dbc61fa5329a6f1f26c517ad.pdf";